import React from "react";
import { EnvironmentCopyPageInitialState, PageNewState } from ".";

export const EnvironmentCopyPageContext = React.createContext({
  pageState: EnvironmentCopyPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
